export default __webpack_public_path__ + "static/media/close.7d6b249f.svg";